import React from "react";
import styles from "./LoadingIndicator.module.css";

export default function LoadingIndicator({ title, description }) {
  return (
    <div className={styles.container}>
      <div className={styles.spinnerRow}>
        <div className={styles.spinner} />
      </div>

      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </div>
  );
}